module.exports = __webpack_public_path__ + "static/media/recipe.c21db91b.svg";